import * as React from "react";
import { Navigate, Outlet } from "react-router";

import { useDocumentAuthoringAccess } from "@/hooks/use-document-authoring-access";

export const DocumentAuthoringRouteGate: React.FC = () => {
  const { isResolved, hasDocumentAuthoring } = useDocumentAuthoringAccess();

  if (!isResolved) return null;

  if (!hasDocumentAuthoring) return <Navigate to="/drive" replace />;

  return <Outlet />;
};
